export const RESOURCES_FOLDER = '/museo/';
const suffix = '';
export const RESOURCE_URL = `{0}/{1}${suffix}`;
export const getResourcePath = (folder: string, resource: string) => RESOURCE_URL.replace('{0}', folder).replace('{1}', resource);
export const getResource = (folder: string, resource: string = '') => `${RESOURCES_FOLDER}${getResourcePath(folder, resource)}`;

